// Client API frontend pour l'intégration trafic temps réel TomTom.

const BASE = "https://support.gs-group.fr/api";
const tok = () => localStorage.getItem("nexo_token");
const h = () => ({ Authorization: "Bearer " + tok() });
const hJson = () => ({ ...h(), "Content-Type": "application/json" });

async function getConfig() {
  return fetch(`${BASE}/tomtom/config`, { headers: h() }).then(r => r.json());
}

/** @param {object} cfg {enabled, apiKey?} */
async function saveConfig(cfg) {
  const r = await fetch(`${BASE}/tomtom/config`, { method: "POST", headers: hJson(), body: JSON.stringify(cfg) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

async function testConfig(cfg) {
  const r = await fetch(`${BASE}/tomtom/config/test`, { method: "POST", headers: hJson(), body: JSON.stringify(cfg) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/** @returns {Promise<boolean>} le calque trafic peut-il être proposé sur la carte (tout utilisateur connecté) */
async function isAvailable() {
  const d = await fetch(`${BASE}/tomtom/traffic-available`, { headers: h() }).then(r => r.json()).catch(() => ({}));
  return !!d.available;
}

/** @returns {Promise<{id:number, nom:string, lat:number, lng:number, rayon_km:number}[]>} */
async function getZones() {
  const d = await fetch(`${BASE}/tomtom/zones`, { headers: h() }).then(r => r.json()).catch(() => []);
  return Array.isArray(d) ? d : [];
}

/** @param {string} nom nom de ville, géocodé automatiquement côté serveur (ex: "Colmar") */
async function addZone(nom, rayon_km) {
  const r = await fetch(`${BASE}/tomtom/zones`, { method: "POST", headers: hJson(), body: JSON.stringify({ nom, rayon_km }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

async function deleteZone(id) {
  await fetch(`${BASE}/tomtom/zones/${id}`, { method: "DELETE", headers: h() });
}

/** @param {string} adresse adresse texte du siège/dépôt, géocodée automatiquement côté serveur */
async function saveDepot(adresse) {
  const r = await fetch(`${BASE}/tomtom/depot`, { method: "POST", headers: hJson(), body: JSON.stringify({ adresse }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

/** URL de tuile trafic à passer directement à L.tileLayer (proxy backend, clé jamais exposée). */
function tileUrlTemplate() {
  return `${BASE}/tomtom/tile/{z}/{x}/{y}?token=${tok()}`;
}

/** @param {string} interventionId @returns {Promise<{travelTimeSec:number, trafficDelaySec:number, distanceKm:number}>} */
async function getEtaForIntervention(interventionId) {
  const r = await fetch(`${BASE}/tomtom/eta/intervention/${interventionId}`, { headers: h() });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || `Erreur ${r.status}`);
  return d;
}

export const tomtomApi = { getConfig, saveConfig, testConfig, isAvailable, getZones, addZone, deleteZone, saveDepot, tileUrlTemplate, getEtaForIntervention };
